import {
    updateSync,
    incrementSyncQueue,
    decrementSyncQueue,
    updateSyncId,
    updateDisplayedMap,
    updateActiveMap
} from "../../../redux_actions/gamma.state.action";
import {
    clearMapsStateNotForSlideIds,
    initMapsState,
    updateMapState
} from "../../../redux_actions/maps.state.action";
import {store} from "../../../helper/store";
import {clipValue} from "../../../utils/utils";
import {
    clearAllSlidesFromSplitSyncView,
    replaceSlidesInSplitSyncView
} from "../../../redux_actions/splitSyncSlides.action";

export const mapSlides = (selectedSlides) => {
    store.dispatch(replaceSlidesInSplitSyncView(selectedSlides))
    store.dispatch(initMapsState(selectedSlides.map(slide => ({slideId: slide.id}))));
}

export const reset = () => {
    const maps = Object.values(store.getState().mapsStateReducer);
    const slideIds = maps.slice(0, 1).map(map => map.slide.id);
    store.dispatch(updateDisplayedMap(maps[0].id));
    store.dispatch(updateActiveMap(maps[0].id));
    store.dispatch(clearMapsStateNotForSlideIds(slideIds));
    store.dispatch(clearAllSlidesFromSplitSyncView());
}
export const saveMapsPosition = mapsState => {
    for (let map_id in mapsState) {
        let mapState = mapsState[map_id];
        // saving current state to use in sync mode, not changing the object pointer as not dispatching
        mapState.X = mapState.x;
        mapState.Y = mapState.y;
        mapState.Z = mapState.z;
        mapState.R = mapState.r;
        mapState.lastCenter = null;
        mapState.transition = null;
    }
}

export const toggleSync = () => {
    let mapsState = store.getState().mapsStateReducer;
    let gammaState = store.getState().gammaStateReducer;
    if (Object.keys(mapsState).length < 2) return;
    !gammaState.sync && saveMapsPosition(mapsState);
    store.dispatch(updateSync(!gammaState.sync));
}

// [Priyanshu]: idea is not to access the current position of the other views, as it makes things unstable
// algorithm is written such that it only uses the current position of the view which is in motion
// this conclusion is reached after doing multiple tests
export const syncViews = (event) => {
    let sourceMapId = event.target.getProperties().mapId;
    let mapsState = store.getState().mapsStateReducer;
    let gammaState = store.getState().gammaStateReducer;
    let n_maps = Object.keys(mapsState).length;
    if (n_maps < 2 || !gammaState.sync) return;
    let sourceMapState = mapsState[sourceMapId];
    if (gammaState.syncQueue === 0 || gammaState.syncId === sourceMapId) {
        store.dispatch(updateSyncId(sourceMapState))
        store.dispatch(incrementSyncQueue());
        let {slidemap, X, Y, Z, R} = sourceMapState;
        let [x, y] = slidemap.getView().getCenter();
        let [oldX, oldY] = sourceMapState.lastCenter || [X, Y];
        let dx = x - oldX;
        let dy = y - oldY;
        let dr = slidemap.getView().getRotation() - R;
        let dz = 0;
        store.dispatch(updateMapState(sourceMapId, {lastCenter: [x, y]}))

        if (event.type === 'change:resolution') {
            let previousZoom = sourceMapState.z;
            dz = (sourceMapState.z != Math.round(slidemap.getView().getZoom())) ? Math.round(slidemap.getView().getZoom() - previousZoom) : 0;
            let transition = {start: Math.round(previousZoom), end: Math.round(slidemap.getView().getZoom())};
            if (sourceMapState.transition && sourceMapState.transition.end == transition.end) {
                dz = 0;
            } else if (sourceMapState.transition) {
                dz = transition.end - sourceMapState.transition.end;
                store.dispatch(updateMapState(sourceMapId, {transition: transition}))
            } else {
                store.dispatch(updateMapState(sourceMapId, {transition: transition}))
            }
        }

        Object.values(mapsState).forEach(mapState => {
            if (mapState.id === sourceMapId) return;
            let cos = Math.cos(R - mapState.R);
            let sin = Math.sin(R - mapState.R);
            let [x, y] = mapState.slidemap.getView().getCenter();
            let [minX, minY, maxX, maxY] = mapState.slidemap.getView().getProjection().getExtent();
            let [oldX, oldY] = [x, y];
            let newX = clipValue(oldX + dx * cos + dy * sin, minX, maxX);
            let newY = clipValue(oldY + dy * cos - dx * sin, minY, maxY);
            let z = Math.round(mapState.slidemap.getView().getZoom());
            let newZ = clipValue(z + dz, 0, mapState.zoomLevels.length - 1);
            let newCenter = [newX, newY];
            store.dispatch(updateMapState(mapState.id, {lastCenter: [newX, newY], transition: {start: z, end: newZ}}))

            mapState.slidemap.getView().animate({
                center: newCenter,
                zoom: newZ,
                rotation: mapState.R + dr,
                duration: 60
                // eslint-disable-next-line no-loop-func
            }, () => {
                if (--n_maps <= 1) store.dispatch(decrementSyncQueue());
            });
        })
    }
}
